import { graphql } from 'gql';

export const bimExportWorkOrderChangeGql = graphql(`
    query bimExportWorkOrderChange($workOrderChangeId: Long!) {
        bimExportWorkOrderChange(workOrderChangeId: $workOrderChangeId) {
            data {
                count
                dataUrl
                name
                size
            }
            result
            message
            buttonText
            code
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);
